import styled from 'styled-components';

export default styled.p`
  margin: 0 0 1.3rem;

  &:last-child {
    margin: 0;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Typography/P.js